import { createAction } from "redux-actions";
import { createSelector } from "reselect";
import { path, prop, identity } from "ramda";

// Actions
export const SWITCH_EDIT_MODE_ANNOTATIONS = "APP@ANNOTATIONS::SWITCH_EDIT_MODE";

// Action Creators
export const switchEditMode = createAction(SWITCH_EDIT_MODE_ANNOTATIONS);

// Selectors
const getAnnotations = path(["application", "annotations"]);
export const selectAnnotations = createSelector(getAnnotations, identity);
export const selectEditMode = createSelector(getAnnotations, prop("mode"));

// Initial State
const initialState = () => ({
  mode: -2
});

// Reducer
export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    case SWITCH_EDIT_MODE_ANNOTATIONS:
      return { ...state, mode: action.payload };
    default:
      return state;
  }
}
